"use strict";
/**
 * Created by Pankaj on 2019-12-20.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoPanelButtonIDs = void 0;
var PromoPanelButtonIDs;
(function (PromoPanelButtonIDs) {
    PromoPanelButtonIDs["CLOSE"] = "CLOSE";
    PromoPanelButtonIDs["NOLIMIT_WINNERS"] = "NOLIMIT_WINNERS";
    PromoPanelButtonIDs["TOURNAMENTS"] = "TOURNAMENTS";
    PromoPanelButtonIDs["VOUCHER"] = "VOUCHER";
    PromoPanelButtonIDs["NOLIMIT_BONUS"] = "NOLIMIT_BONUS";
    PromoPanelButtonIDs["BET_DOWN"] = "BET_DOWN";
    PromoPanelButtonIDs["BET_UP"] = "BET_UP";
    PromoPanelButtonIDs["BUY"] = "BUY_BTN";
    PromoPanelButtonIDs["OK_BTN"] = "OK_BTN";
    PromoPanelButtonIDs["POP_UP_CLOSE"] = "POP_UP_CLOSE";
    //REPLAY
    PromoPanelButtonIDs["CURRENT_GAME_BTN"] = "CURRENT_GAME_BTN";
    PromoPanelButtonIDs["ALL_GAME_BTN"] = "ALL_GAME_BTN";
    PromoPanelButtonIDs["SINGLE_PLAYER_BTN"] = "SINGLE_PLAYER_BTN";
    PromoPanelButtonIDs["ALL_PLAYER_BTN"] = "ALL_PLAYER_BTN";
    PromoPanelButtonIDs["X_BET_FILTER_BTN"] = "X_BET_FILTER_BTN";
    PromoPanelButtonIDs["X_WIN_FILTER_BTN"] = "X_WIN_FILTER_BTN";
    PromoPanelButtonIDs["PLAY_BTN"] = "PLAY_BTN";
    PromoPanelButtonIDs["CAP_WIN_TOGGLE"] = "capWinToggleButton";
    // Action Spins
    PromoPanelButtonIDs["ACTION_SPINS"] = "ACTION_SPINS";
    PromoPanelButtonIDs["ACTION_SPINS_BET_UP"] = "ACTION_SPINS_BET_UP";
    PromoPanelButtonIDs["ACTION_SPINS_BET_DOWN"] = "ACTION_SPINS_BET_DOWN";
    PromoPanelButtonIDs["ACTION_SPINS_COUNT_DOWN"] = "ACTION_SPINS_COUNT_DOWN";
    PromoPanelButtonIDs["ACTION_SPINS_COUNT_UP"] = "ACTION_SPINS_COUNT_UP";
    PromoPanelButtonIDs["ACTION_SPINS_SPIN_BUTTON"] = "ACTION_SPINS_SPIN_BUTTON";
    PromoPanelButtonIDs["ACTION_SPINS_SPIN_STOP_BUTTON"] = "ACTION_SPINS_SPIN_STOP_BUTTON";
    PromoPanelButtonIDs["ACTION_SPIN_STOP_ON_BONUS_TRIGGERED"] = "ACTION_SPIN_STOP_ON_BONUS_TRIGGERED";
    PromoPanelButtonIDs["ACTION_SPINS_SETTINGS"] = "ACTION_SPINS_SETTINGS";
    PromoPanelButtonIDs["ACTION_SPINS_BONUS_BUY"] = "ACTION_SPINS_BONUS_BUY";
    PromoPanelButtonIDs["ACTION_SPINS_MAIN_GAME"] = "ACTION_SPINS_MAIN_GAME";
    PromoPanelButtonIDs["ACTION_SPINS_BONUS_BUY_LABEL"] = "Nolimit Bonus";
    PromoPanelButtonIDs["ACTION_SPINS_MAIN_GAME_LABEL"] = "Main Game";
    PromoPanelButtonIDs["ACTION_SPINS_BONUS_PICK_POP_UP_CLOSE"] = "BONUS_PICK_POP_UP_CLOSE";
    PromoPanelButtonIDs["ACTION_SPINS_REPLAY_EXPAND_BUTTON"] = "ACTION_SPINS_REPLAY_EXPAND_BUTTON";
    PromoPanelButtonIDs["ACTION_SPINS_REPLAY_REPLAY_BUTTON"] = "ACTION_SPINS_REPLAY_REPLAY_BUTTON";
    PromoPanelButtonIDs["ACTION_SPINS_REPLAY_PAUSE_BUTTON"] = "ACTION_SPINS_REPLAY_PAUSE_BUTTON";
    PromoPanelButtonIDs["ACTION_SPINS_REPLAY_PLAY_BUTTON"] = "ACTION_SPINS_REPLAY_PLAY_BUTTON";
    PromoPanelButtonIDs["ACTION_SPINS_GAME_PLAY_BUTTON"] = "ACTION_SPINS_GAME_PLAY";
    PromoPanelButtonIDs["ACTION_SPINS_GAME_CONTINUE_BUTTON"] = "ACTION_SPINS_GAME_CONTINUE";
    PromoPanelButtonIDs["AS_BONUS_SELECTION_OK_BTN"] = "AS_BONUS_SELECTION_OK_BTN";
    PromoPanelButtonIDs["AS_BONUS_SELECTION_CANCEL_BTN"] = "AS_BONUS_SELECTION_CANCEL_BTN";
})(PromoPanelButtonIDs = exports.PromoPanelButtonIDs || (exports.PromoPanelButtonIDs = {}));
//# sourceMappingURL=PromoPanelButtonIDs.js.map